import { PulseEnvironment } from '@pulse/browser-shared';
import { RUMService } from '@pulse/browser-tracker-shared';
import { AnalyticsPlugin, IPulsePluginContext } from '@pulse/common';

export class RUMPlugin implements AnalyticsPlugin {
    constructor(
        private rum: RUMService,
        private env: PulseEnvironment,
    ) {}

    init(ctx: IPulsePluginContext) {
        this.rum.subscribe(ctx.config.rumReport, ctx.config.rumReportOnce).subscribe((entry) => {
            this.env.win.dataLayer?.push({ pulse: 'event', event: 'rum', data: entry });
        });
    }
}
